import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "How exactly does splitting an order work?",
  answer: "It's effortless. You either browse existing 'HalfOrders' for meals you want or create a new one. Once a nearby user matches with you, we split the bill instantly. You both pick up your portions at the restaurant or a designated safe zone."
}, {
  question: "Is it safe to meet and share food with strangers?",
  answer: "Safety is built into our DNA. Every user is verified via phone and email. We encourage meetings at the restaurant or our verified 'HalfOrder Zones'—high-traffic, well-lit public spots across Toronto like Union Station or the Eaton Centre."
}, {
  question: "Which Toronto restaurants can I order from?",
  answer: "We partner with hundreds of local favorites across the GTA, from Kensington Market gems to downtown staples. If a restaurant offers portions that are better shared, like family-style platters or BOGO deals, they're on the app."
}, {
  question: "How much can I realistically save per month?",
  answer: "Most students and young professionals save between 40-50% on every meal. By splitting large portions or taking advantage of shared discounts that are too big for one person, those savings add up to hundreds of dollars every semester."
}, {
  question: "What happens if my match doesn't show up?",
  answer: "We have a zero-tolerance 'No-Flake' policy. If a match cancels last minute or fails to show, our system automatically compensates you with credits and flags their account. Reliability is what makes our community work."
}];
export default function CommonQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="8510" id="common-questions" className="bg-card/30 py-16 md:py-24 dark text-foreground">
      <div ref={ref} className={cn("container mx-auto px-4 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="mx-auto max-w-[800px]">
          <div className="mb-12 text-center">
            <h2 className="text-4xl font-black tracking-tighter text-foreground sm:text-6xl uppercase">
              The Lowdown
            </h2>
            <p className="mt-4 text-lg md:text-xl text-muted-foreground font-medium">
              Everything you need to know about splitting meals and saving big in Toronto.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border/40 rounded-none px-0 data-[state=open]:border-primary transition-colors duration-300">
                <AccordionTrigger className="text-left text-lg md:text-xl font-black uppercase tracking-tighter text-foreground hover:no-underline py-6 data-[state=open]:text-primary transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-lg leading-relaxed pb-8 font-medium">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}